import styles from "./CommonFields.module.css";
import { RangeSlider, Select } from "@shopify/polaris";
import CustomInputWithUnit from "../../../components/CustomInputWithUnit/CustomInputWithUnit";
import FormSubSection from "./FormSubSection";
import NewCustomColorPicker from "../../../components/NewCustomColorPicker/NewCustomColorPicker";
import { Field } from "@shopify/react-form";
import { BundleTypes, FontStyles } from "../constants";

type Props_DesignFooterCard = {
    dispatchBundleConfig: any;
    bundleType: string;
    cardName?: string;
    showFooterKeys: boolean;
    custom_field_bg_color?: Field<string> | null;
    custom_field_title_color?: Field<string> | null;
    custom_field_message_color?: Field<string> | null;
    total_footer_text_color?: Field<string>;
    total_footer_background_color?: Field<string>;
    footer_save_money_text_color?: Field<string>;
    footer_save_money_text_size?: Field<number> | null;
    footer_save_money_text_style?: Field<string> | null;
    total_footer_text_style?: Field<string> | null;
    total_footer_text_size?: Field<number> | null;
    total_footer_price_text_color?: Field<string> | null;
    total_footer_price_text_style?: Field<string> | null;
    total_footer_price_text_size?: Field<number> | null;
    add_to_cart_bg_color?: Field<string>;
    add_to_cart_border_color?: Field<string>;
    add_to_cart_border_width?: Field<number> | null;
    add_to_cart_text_color?: Field<string>;
    add_to_cart_text_style?: Field<string> | null;
    add_to_cart_border_radius?: Field<number> | null;
    add_to_cart_text_size?: Field<number> | null;
    skip_offer_text_color?: Field<string>;
    skip_offer_text_size?: Field<number> | null;
    skip_offer_text_style?: Field<string> | null;
    // BB_Placeholder Keys
    order_summary_bg_color?: Field<string> | null;
    order_summary_header_text_color?: Field<string> | null;
    order_summary_header_text_size?: Field<number> | null;
    order_summary_header_text_style?: Field<string> | null;
    order_summary_rows_text_color?: Field<string> | null;
    order_summary_rows_text_size?: Field<number> | null;
    order_summary_rows_text_style?: Field<string> | null;
    special_text_background_color?: Field<string>;
    special_text_color?: Field<string>;
    special_text_font_size?: Field<number> | null;
    special_text_style?: Field<string> | null;
};

const DesignFooterCard = ({
    dispatchBundleConfig,
    bundleType,
    showFooterKeys,
    custom_field_bg_color,
    custom_field_title_color,
    custom_field_message_color,
    total_footer_text_color,
    total_footer_background_color,
    footer_save_money_text_color,
    footer_save_money_text_size,
    footer_save_money_text_style,
    total_footer_text_style,
    total_footer_text_size,
    total_footer_price_text_color,
    total_footer_price_text_style,
    total_footer_price_text_size,
    add_to_cart_bg_color,
    add_to_cart_text_color,
    add_to_cart_text_style,
    add_to_cart_border_radius,
    add_to_cart_border_color,
    add_to_cart_border_width,
    add_to_cart_text_size,
    skip_offer_text_color,
    skip_offer_text_size,
    skip_offer_text_style,

    order_summary_bg_color,
    order_summary_header_text_color,
    order_summary_header_text_size,
    order_summary_header_text_style,
    order_summary_rows_text_color,
    order_summary_rows_text_size,
    order_summary_rows_text_style,
    special_text_background_color,
    special_text_color,
    special_text_style,
    special_text_font_size,
}: Props_DesignFooterCard) => {
    return (
        <div>
            {(custom_field_bg_color || custom_field_title_color || custom_field_message_color) && (
                <div id="custom_fields-design">
                    <FormSubSection rowLabel={"Custom Field Section"}>
                        {custom_field_bg_color && (
                            <NewCustomColorPicker
                                hexColor={custom_field_bg_color.value}
                                setHexColor={(val) => {
                                    custom_field_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            custom_field_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{
                                    ...custom_field_bg_color,
                                    onBlur: () => custom_field_bg_color?.runValidation(),
                                }}
                            />
                        )}
                        {custom_field_title_color && (
                            <NewCustomColorPicker
                                hexColor={custom_field_title_color.value}
                                setHexColor={(val) => {
                                    custom_field_title_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            custom_field_title_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Title Text Color"}
                                props={{
                                    ...custom_field_title_color,
                                    onBlur: () => custom_field_title_color?.runValidation(),
                                }}
                            />
                        )}
                        {custom_field_message_color && (
                            <NewCustomColorPicker
                                hexColor={custom_field_message_color.value}
                                setHexColor={(val) => {
                                    custom_field_message_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            custom_field_message_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Message Text Color"}
                                props={{
                                    ...custom_field_message_color,
                                    onBlur: () => custom_field_message_color?.runValidation(),
                                }}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}

            {order_summary_bg_color && (
                <div id="order_summary-design">
                    <FormSubSection rowLabel={"Order Summary Card"}>
                        {order_summary_bg_color && (
                            <NewCustomColorPicker
                                hexColor={order_summary_bg_color.value}
                                setHexColor={(val) => {
                                    order_summary_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            order_summary_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{
                                    ...order_summary_bg_color,
                                    onBlur: () => order_summary_bg_color?.runValidation(),
                                }}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {bundleType != BundleTypes.BB_PLACEHOLDER &&
                (order_summary_header_text_color ||
                    order_summary_header_text_size ||
                    order_summary_header_text_style) && (
                    <FormSubSection rowLabel={"Order Summary Header and Total"}>
                        {order_summary_header_text_color && (
                            <NewCustomColorPicker
                                hexColor={order_summary_header_text_color.value}
                                setHexColor={(val) => {
                                    order_summary_header_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            order_summary_header_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Headers Text Color"}
                                props={{
                                    ...order_summary_header_text_color,
                                    onBlur: () => order_summary_header_text_color?.runValidation(),
                                }}
                            />
                        )}
                        {order_summary_header_text_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    order_summary_header_text_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            order_summary_header_text_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={order_summary_header_text_size?.value}
                                unitSuffix={"px"}
                                props={{
                                    ...order_summary_header_text_size,
                                    onBlur: () => order_summary_header_text_size?.runValidation(),
                                }}
                            />
                        )}
                        {order_summary_header_text_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    order_summary_header_text_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            order_summary_header_text_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={order_summary_header_text_style.value}
                            />
                        )}
                    </FormSubSection>
                )}
            {bundleType != BundleTypes.BB_PLACEHOLDER &&
                (order_summary_rows_text_color || order_summary_rows_text_size || order_summary_rows_text_style) && (
                    <FormSubSection rowLabel={"Order Summary Rows"}>
                        {order_summary_rows_text_color && (
                            <NewCustomColorPicker
                                hexColor={order_summary_rows_text_color.value}
                                setHexColor={(val) => {
                                    order_summary_rows_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            order_summary_rows_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Rows Text Color"}
                                props={{
                                    ...order_summary_rows_text_color,
                                    onBlur: () => order_summary_rows_text_color?.runValidation(),
                                }}
                            />
                        )}

                        {order_summary_rows_text_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    order_summary_rows_text_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            order_summary_rows_text_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={order_summary_rows_text_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...order_summary_rows_text_size,
                                    onBlur: () => order_summary_rows_text_size?.runValidation(),
                                }}
                            />
                        )}
                        {order_summary_rows_text_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    order_summary_rows_text_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            order_summary_rows_text_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={order_summary_rows_text_style.value}
                            />
                        )}
                    </FormSubSection>
                )}

            {bundleType == BundleTypes.BB_PLACEHOLDER &&
                (order_summary_header_text_color ||
                    order_summary_header_text_size ||
                    order_summary_header_text_style ||
                    order_summary_rows_text_color ||
                    order_summary_rows_text_size ||
                    order_summary_rows_text_style) && (
                    <div id="order-summary-header-design">
                        <FormSubSection rowLabel={"Order Summary and Total"}>
                            {order_summary_header_text_color && (
                                <NewCustomColorPicker
                                    hexColor={order_summary_header_text_color.value}
                                    setHexColor={(val) => {
                                        order_summary_header_text_color.onChange(val);
                                        dispatchBundleConfig({
                                            payload: {
                                                order_summary_header_text_color: val,
                                            },
                                            isComplex: true,
                                            key: "bundles_design",
                                        });
                                    }}
                                    label={"Label Text Color"}
                                    props={{
                                        ...order_summary_header_text_color,
                                        onBlur: () => order_summary_header_text_color?.runValidation(),
                                    }}
                                />
                            )}
                            {order_summary_header_text_size && (
                                <CustomInputWithUnit
                                    min={0}
                                    label={"Label Size"}
                                    placeholder={"font size"}
                                    setValue={(val) => {
                                        order_summary_header_text_size.onChange(+val);
                                        dispatchBundleConfig({
                                            payload: {
                                                order_summary_header_text_size: +val,
                                            },
                                            isComplex: true,
                                            key: "bundles_design",
                                        });
                                    }}
                                    value={order_summary_header_text_size?.value}
                                    unitSuffix={"px"}
                                    props={{
                                        ...order_summary_header_text_size,
                                        onBlur: () => order_summary_header_text_size?.runValidation(),
                                    }}
                                />
                            )}
                            {order_summary_header_text_style && (
                                <Select
                                    label={"Label Style"}
                                    options={FontStyles}
                                    placeholder={"Font style"}
                                    onChange={(val) => {
                                        order_summary_header_text_style.onChange(val);
                                        dispatchBundleConfig({
                                            payload: {
                                                order_summary_header_text_style: val,
                                            },
                                            isComplex: true,
                                            key: "bundles_design",
                                        });
                                    }}
                                    value={order_summary_header_text_style.value}
                                />
                            )}
                            {order_summary_rows_text_color && (
                                <NewCustomColorPicker
                                    hexColor={order_summary_rows_text_color.value}
                                    setHexColor={(val) => {
                                        order_summary_rows_text_color.onChange(val);
                                        dispatchBundleConfig({
                                            payload: {
                                                order_summary_rows_text_color: val,
                                            },
                                            isComplex: true,
                                            key: "bundles_design",
                                        });
                                    }}
                                    label={"Value Text Color"}
                                    props={{
                                        ...order_summary_rows_text_color,
                                        onBlur: () => order_summary_rows_text_color?.runValidation(),
                                    }}
                                />
                            )}

                            {order_summary_rows_text_size && (
                                <CustomInputWithUnit
                                    min={0}
                                    label={"Value Size"}
                                    placeholder={"font size"}
                                    setValue={(val) => {
                                        order_summary_rows_text_size.onChange(+val);
                                        dispatchBundleConfig({
                                            payload: {
                                                order_summary_rows_text_size: +val,
                                            },
                                            isComplex: true,
                                            key: "bundles_design",
                                        });
                                    }}
                                    value={order_summary_rows_text_size.value}
                                    unitSuffix={"px"}
                                    props={{
                                        ...order_summary_rows_text_size,
                                        onBlur: () => order_summary_rows_text_size?.runValidation(),
                                    }}
                                />
                            )}
                            {order_summary_rows_text_style && (
                                <Select
                                    label={"Value Style"}
                                    options={FontStyles}
                                    placeholder={"Font style"}
                                    onChange={(val) => {
                                        order_summary_rows_text_style.onChange(val);
                                        dispatchBundleConfig({
                                            payload: {
                                                order_summary_rows_text_style: val,
                                            },
                                            isComplex: true,
                                            key: "bundles_design",
                                        });
                                    }}
                                    value={order_summary_rows_text_style.value}
                                />
                            )}
                        </FormSubSection>
                    </div>
                )}

            {(total_footer_background_color ||
                total_footer_text_color ||
                total_footer_text_size ||
                total_footer_text_style ||
                total_footer_price_text_color ||
                total_footer_price_text_size ||
                total_footer_price_text_style) && (
                <div id="footer-total">
                    <FormSubSection rowLabel={"Total Section"}>
                        {total_footer_background_color && (
                            <NewCustomColorPicker
                                hexColor={total_footer_background_color.value}
                                setHexColor={(val) => {
                                    total_footer_background_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            total_footer_background_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{
                                    ...total_footer_background_color,
                                    onBlur: () => total_footer_background_color?.runValidation(),
                                }}
                            />
                        )}
                        {total_footer_text_color && (
                            <NewCustomColorPicker
                                hexColor={total_footer_text_color.value}
                                setHexColor={(val) => {
                                    total_footer_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            total_footer_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{
                                    ...total_footer_text_color,
                                    onBlur: () => total_footer_text_color?.runValidation(),
                                }}
                            />
                        )}

                        {total_footer_text_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Total Text Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    total_footer_text_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            total_footer_text_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={total_footer_text_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...total_footer_text_size,
                                    onBlur: () => total_footer_text_size?.runValidation(),
                                }}
                            />
                        )}
                        {total_footer_text_style && (
                            <Select
                                label={"Total Text Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    total_footer_text_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            total_footer_text_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={total_footer_text_style.value}
                            />
                        )}
                        {total_footer_price_text_color && (
                            <NewCustomColorPicker
                                hexColor={total_footer_price_text_color.value}
                                setHexColor={(val) => {
                                    total_footer_price_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            total_footer_price_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Price Text Color"}
                                props={{
                                    ...total_footer_price_text_color,
                                    onBlur: () => total_footer_price_text_color?.runValidation(),
                                }}
                            />
                        )}
                        {total_footer_price_text_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Price Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    total_footer_price_text_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            total_footer_price_text_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={total_footer_price_text_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...total_footer_price_text_size,
                                    onBlur: () => total_footer_price_text_size?.runValidation(),
                                }}
                            />
                        )}
                        {total_footer_price_text_style && (
                            <Select
                                label={"Price Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    total_footer_price_text_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            total_footer_price_text_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={total_footer_price_text_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {(footer_save_money_text_color || footer_save_money_text_size || footer_save_money_text_style) && (
                <div id="footer-save-money">
                    <FormSubSection rowLabel={"Save Price"}>
                        {footer_save_money_text_color && (
                            <NewCustomColorPicker
                                hexColor={footer_save_money_text_color.value}
                                setHexColor={(val) => {
                                    footer_save_money_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            footer_save_money_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{
                                    ...footer_save_money_text_color,
                                    onBlur: () => footer_save_money_text_color?.runValidation(),
                                }}
                            />
                        )}
                        {footer_save_money_text_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    footer_save_money_text_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            footer_save_money_text_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={footer_save_money_text_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...footer_save_money_text_size,
                                    onBlur: () => footer_save_money_text_size?.runValidation(),
                                }}
                            />
                        )}
                        {footer_save_money_text_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    footer_save_money_text_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            footer_save_money_text_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={footer_save_money_text_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}

            {(special_text_background_color || special_text_color || special_text_font_size || special_text_style) && (
                <div id="special-text-design">
                    <FormSubSection
                        rowLabel={"Special Text"}
                        hideSeparator={
                            BundleTypes.BXGY == bundleType ||
                            (BundleTypes.BB_PLACEHOLDER == bundleType && !showFooterKeys)
                        }
                    >
                        {special_text_background_color && (
                            <NewCustomColorPicker
                                hexColor={special_text_background_color.value}
                                setHexColor={(val) => {
                                    special_text_background_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            special_text_background_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{
                                    ...special_text_background_color,
                                    onBlur: () => special_text_background_color?.runValidation(),
                                }}
                            />
                        )}

                        {special_text_color && (
                            <NewCustomColorPicker
                                hexColor={special_text_color.value}
                                setHexColor={(val) => {
                                    special_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            special_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{ ...special_text_color, onBlur: () => special_text_color?.runValidation() }}
                            />
                        )}

                        {special_text_font_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    special_text_font_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            special_text_font_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={special_text_font_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...special_text_font_size,
                                    onBlur: () => special_text_font_size?.runValidation(),
                                }}
                            />
                        )}
                        {special_text_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    special_text_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            special_text_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={special_text_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}

            {showFooterKeys && (
                <>
                    {(add_to_cart_bg_color ||
                        add_to_cart_text_color ||
                        add_to_cart_text_size ||
                        add_to_cart_text_style ||
                        add_to_cart_border_color ||
                        add_to_cart_border_width) && (
                        <div id="footer-add-to-cart">
                            <FormSubSection
                                rowLabel={"Add to Cart"}
                                // @ts-expect-error required
                                hideSeparator={![BundleTypes.PRODUCT_ADDONS_POPUP]?.includes(bundleType)}
                            >
                                {add_to_cart_bg_color && (
                                    <NewCustomColorPicker
                                        hexColor={add_to_cart_bg_color.value}
                                        setHexColor={(val) => {
                                            add_to_cart_bg_color.onChange(val);
                                            dispatchBundleConfig({
                                                payload: {
                                                    add_to_cart_bg_color: val,
                                                },
                                                isComplex: true,
                                                key: "bundles_design",
                                            });
                                        }}
                                        label={"Background Color"}
                                        props={{
                                            ...add_to_cart_bg_color,
                                            onBlur: () => add_to_cart_bg_color?.runValidation(),
                                        }}
                                    />
                                )}
                                {add_to_cart_text_color && (
                                    <NewCustomColorPicker
                                        hexColor={add_to_cart_text_color.value}
                                        setHexColor={(val) => {
                                            add_to_cart_text_color.onChange(val);
                                            dispatchBundleConfig({
                                                payload: {
                                                    add_to_cart_text_color: val,
                                                },
                                                isComplex: true,
                                                key: "bundles_design",
                                            });
                                        }}
                                        label={"Text Color"}
                                        props={{
                                            ...add_to_cart_text_color,
                                            onBlur: () => add_to_cart_text_color?.runValidation(),
                                        }}
                                    />
                                )}

                                {add_to_cart_text_size && (
                                    <CustomInputWithUnit
                                        min={0}
                                        label={"Size"}
                                        placeholder={"font size"}
                                        setValue={(val) => {
                                            add_to_cart_text_size.onChange(+val);
                                            dispatchBundleConfig({
                                                payload: {
                                                    add_to_cart_text_size: +val,
                                                },
                                                isComplex: true,
                                                key: "bundles_design",
                                            });
                                        }}
                                        value={add_to_cart_text_size.value}
                                        unitSuffix={"px"}
                                        props={{
                                            ...add_to_cart_text_size,
                                            onBlur: () => add_to_cart_text_size?.runValidation(),
                                        }}
                                    />
                                )}
                                {add_to_cart_text_style && (
                                    <Select
                                        label={"Style"}
                                        options={FontStyles}
                                        placeholder={"Font style"}
                                        onChange={(val) => {
                                            add_to_cart_text_style.onChange(val);
                                            dispatchBundleConfig({
                                                payload: {
                                                    add_to_cart_text_style: val,
                                                },
                                                isComplex: true,
                                                key: "bundles_design",
                                            });
                                        }}
                                        value={add_to_cart_text_style.value}
                                    />
                                )}
                                {add_to_cart_border_color && (
                                    <NewCustomColorPicker
                                        hexColor={add_to_cart_border_color.value}
                                        setHexColor={(val) => {
                                            add_to_cart_border_color.onChange(val);
                                            dispatchBundleConfig({
                                                payload: {
                                                    add_to_cart_border_color: val,
                                                },
                                                isComplex: true,
                                                key: "bundles_design",
                                            });
                                        }}
                                        label={"Border Color"}
                                        props={{
                                            ...add_to_cart_border_color,
                                            onBlur: () => add_to_cart_border_color?.runValidation(),
                                        }}
                                    />
                                )}
                                {add_to_cart_border_width && (
                                    <CustomInputWithUnit
                                        min={0}
                                        label={"Border Width"}
                                        placeholder={"border width"}
                                        setValue={(val) => {
                                            add_to_cart_border_width.onChange(+val);
                                            dispatchBundleConfig({
                                                payload: {
                                                    add_to_cart_border_width: +val,
                                                },
                                                isComplex: true,
                                                key: "bundles_design",
                                            });
                                        }}
                                        value={add_to_cart_border_width.value}
                                        unitSuffix={"px"}
                                        props={{
                                            ...add_to_cart_border_width,
                                            onBlur: () => add_to_cart_border_width.runValidation(),
                                        }}
                                    />
                                )}
                                {add_to_cart_border_radius && (
                                    <span className={styles.rangeSliderOverride}>
                                        <RangeSlider
                                            min={0}
                                            max={100}
                                            label={"Border Radius"}
                                            value={add_to_cart_border_radius.value}
                                            onChange={(val) => {
                                                add_to_cart_border_radius.onChange(+val);
                                                dispatchBundleConfig({
                                                    payload: {
                                                        add_to_cart_border_radius: +val,
                                                    },
                                                    isComplex: true,
                                                    key: "bundles_design",
                                                });
                                            }}
                                            output
                                            suffix={(add_to_cart_border_radius.value || 0) + "px"}
                                            error={add_to_cart_border_radius.error}
                                            onBlur={() => add_to_cart_border_radius?.runValidation()}
                                        />
                                    </span>
                                )}
                            </FormSubSection>
                        </div>
                    )}
                </>
            )}

            {(skip_offer_text_color || skip_offer_text_size || skip_offer_text_style) && (
                <div id="footer-skip-offer-text">
                    <FormSubSection rowLabel={"Skip Offer"} hideSeparator={true}>
                        {skip_offer_text_color && (
                            <NewCustomColorPicker
                                hexColor={skip_offer_text_color.value}
                                setHexColor={(val) => {
                                    skip_offer_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            skip_offer_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{
                                    ...skip_offer_text_color,
                                    onBlur: () => skip_offer_text_color?.runValidation(),
                                }}
                            />
                        )}
                        {skip_offer_text_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    skip_offer_text_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            skip_offer_text_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={skip_offer_text_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...skip_offer_text_size,
                                    onBlur: () => skip_offer_text_size?.runValidation(),
                                }}
                            />
                        )}
                        {skip_offer_text_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    skip_offer_text_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            skip_offer_text_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={skip_offer_text_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
        </div>
    );
};

export default DesignFooterCard;
